import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    root: { 
        top: 0,
        position: 'sticky',
        overflow: 'auto',
        height: `calc(100vh - ${72 + Number(theme.spacing(4).replace('px', ''))}px)`
    },
    summary: {
        maxWidth: '99%'
    },
    btnCancel: {
        width: '100%'
    },
    paper: {
        padding: theme.spacing(1)
    }
}));